import React from 'react';
import {ResponseAchieveRecommend} from '../../../../types/MyDynamicsData';
import {useTranslation} from 'react-i18next';
import s from './AchieveRecommend.module.css';

const AchieveRecommend = ({data}: {data: ResponseAchieveRecommend}) => {
	const {t} = useTranslation();
	return (
		<div className={s.achieveRecommend}>
			{data.qlfc_name && (
				<div className={s.dynamicColumn}>
					<button className={s.achieveButton}>
						<div className={s.achieveTitle}>
							{t('Найближча кваліфікація')}:
						</div>
						<div className={s.achieveIcon}>
							{data.qlfc_name}
						</div>
					</button>
				</div>
			)}
		</div>
	);
};

export default AchieveRecommend;
